import type { MentionType } from '../../graphql/generated/graphql';
import type { MentionBehavior } from '../../integrations/IntegrationMentions';
import INTEGRATION_MENTIONS from '../../integrations/IntegrationMentions';

const EDITOR_INTEGRATION_MENTIONS: {
  [key: string]:
    | (MentionBehavior<string> & { apiEnum: MentionType; type: string })
    | undefined;
} = Object.entries(INTEGRATION_MENTIONS)
  .filter(([, { parseUrl }]) => !!parseUrl)
  .reduce(
    (memo, [apiEnum, info]) => ({
      ...memo,
      [info.mentionType]: { ...info, apiEnum, type: apiEnum },
    }),
    {},
  );

export default EDITOR_INTEGRATION_MENTIONS;
